var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.user.rolesDisplay),function(role){return _c('span',{staticClass:"label",class:'label-' + role.colorClass},[_vm._v("\n        "+_vm._s(role.name)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }